import { IFilterOptions } from './types';
import { getMetricsMapping } from '../utils';

export const createFilterOptions = (data) => {
  const filterOptions: IFilterOptions = {
    cdnOptions: [],
    asnOptions: [],
    dmaOptions: [],
    policyOptions: [],
    triggerKpiOptions: [],
  };

  data.forEach((item) => {
    if (item.resource && !filterOptions.cdnOptions.some((option) => option.key === item.resource)) {
      filterOptions.cdnOptions.push({ key: item.resource, label: item.resource });
    }

    if (item.asnname && !filterOptions.asnOptions.some((option) => option.key === item.asnname)) {
      filterOptions.asnOptions.push({ key: item.asnname, label: item.asn + ' - ' + item.asnname });
    }

    if (item.dmaname && !filterOptions.dmaOptions.some((option) => option.key === item.dmaname)) {
      filterOptions.dmaOptions.push({ key: item.dmaname, label: item.dma + ' - ' + item.dmaname });
    }

    if (item.policy && !filterOptions.policyOptions.some((option) => option.key === item.policy)) {
      filterOptions.policyOptions.push({ key: item.policy, label: item.policy });
    }
  });

  const metricsMapping = getMetricsMapping();
  Object.keys(metricsMapping).forEach((key) => {
    filterOptions.triggerKpiOptions.push({ key, label: metricsMapping[key] });
  });

  return filterOptions;
};
